import type { QueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/store/auth';
import { queryClient } from './queryClient';
import { meQuery, settingsQuery, translateConfigQuery } from './queries';

/**
 * Kicks off the queries the first screen needs, in parallel, before React
 * renders — instead of the old waterfall where `RequireAuth` blocked on `/me`
 * and only the mounted Translate page requested config and settings. Errors
 * are swallowed by `prefetchQuery`; the auth flow (401 → refresh → /login)
 * behaves exactly as when the hooks issue these requests themselves.
 */
export function prefetchStartupQueries(client: QueryClient = queryClient): void {
  // No persisted access token — the user lands on /login, nothing to warm up.
  if (!useAuthStore.getState().accessToken) return;
  void client.prefetchQuery(meQuery);
  void client.prefetchQuery(translateConfigQuery);
  void client.prefetchQuery(settingsQuery);
}
